import React, { useEffect, useState } from "react";
import { PiSnowflakeFill } from "react-icons/pi";
import styles from "./WeekStreakRow.module.css";

const DAY_LABELS = ["D", "S", "T", "Q", "Q", "S", "S"]; // Dom..Sáb (getDay 0..6)

/**
 * Linha da semana do streak.
 *
 * Props:
 *   activeDays:  number[] — índices (0-6) já defendidos antes de hoje
 *   frozenDays:  number[] — índices (0-6) de dias congelados desta semana
 *   todayIdx:    number   — índice de hoje (0-6) -> destaque
 *   newDayIdx:   number   — dia que acabou de ser defendido (anima check + arco)
 *   play:        boolean  — dispara a marcação do novo dia
 */
export default function WeekStreakRow({ activeDays = [], frozenDays = [], todayIdx = 0, newDayIdx = null, play = false }) {
  const active = new Set(activeDays);
  const frozen = new Set(frozenDays);
  const [markNew, setMarkNew] = useState(false);

  useEffect(() => {
    if (play) {
      const t = setTimeout(() => setMarkNew(true), 250);
      return () => clearTimeout(t);
    }
    setMarkNew(false);
  }, [play]);

  return (
    <div className={styles.weekRow}>
      {DAY_LABELS.map((label, idx) => {
        const isNew = idx === newDayIdx;
        const justMarked = isNew && markNew;
        const isFrozen = frozen.has(idx);
        const isActive = !isFrozen && (active.has(idx) || justMarked);
        const isToday = idx === todayIdx;

        return (
          <div key={idx} className={styles.dayItem}>
            <span className={`${styles.dayLabel} ${isToday ? styles.dayLabelToday : ""}`}>
              {label}
            </span>
            {isFrozen ? (
              <div className={`${styles.dayDot} ${styles.dayDotFrozen}`}>
                <PiSnowflakeFill className={styles.dayFrozenIcon} />
              </div>
            ) : (
              <div
                className={[
                  styles.dayDot,
                  isActive ? styles.dayDotActive : "",
                  isToday ? styles.dayDotToday : "",
                  justMarked ? styles.dayDotPop : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                {justMarked && <span className={styles.dayRing} />}
                {isActive && (
                  <svg className={styles.dayCheck} viewBox="0 0 12 12" fill="none">
                    <path
                      d="M2.5 6l2.5 2.5 4.5-5"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}